import { all } from 'redux-saga/effects';
import donationFormSagas from './donationForm';
import analyticsSagas from './analytics';

export default function* rootSaga() {
  yield all([...donationFormSagas(), ...analyticsSagas()]);
}
